import React from 'react';
import { IIconProps } from './IIconProps';

export const CloseIcon = ({
	iconClass = '',
	title = '',
	onClick,
	pointer,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 18 18"
			className={`stroke ${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path d="M17 1L1 17M1 1L17 17" />
		</svg>
	);
};
